import { DashboardPage } from 'foundations-components/transitional/components/DashboardPage';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { UsageScreenProvider } from 'marketplace-ui-tracking';
import { NavMarker } from 'react-rhumb';
import { CollectionSection } from '../components/CollectionSection';
import { Hero } from '../components/Hero';
import { SliderSection, translateSectionTitle } from '../components/SliderSection';
import { HomepageHeader } from '../components/headers/HomepageHeader';
import { Screens } from '../constants/usage';
import { useGetSuggestionSections } from '../hooks/useGetSuggestionSections';
import { useSplitSuggestionSections } from '../hooks/useSplitSuggestionSections';
import { useTrackHomepageViewedEvent } from '../hooks/useTrackHomepageViewedEvent';
import { createMockCollection, createMockListing } from '../queries/mockHomepageData';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function Home() {
  const {
    loading,
    error,
    data
  } = useGetSuggestionSections();
  const {
    sections,
    remainingSections
  } = useSplitSuggestionSections({
    suggestionSections: data === null || data === void 0 ? void 0 : data.result.sections,
    start: 0,
    end: 2
  });
  useTrackHomepageViewedEvent({
    loading,
    screen: Screens.HOME,
    sections: data === null || data === void 0 ? void 0 : data.result.sections
  });
  return /*#__PURE__*/_jsx(UsageScreenProvider, {
    screen: Screens.HOME,
    children: /*#__PURE__*/_jsxs(DashboardPage, {
      headerComponent: /*#__PURE__*/_jsx(HomepageHeader, {}),
      children: [/*#__PURE__*/_jsx(Hero, {
        text: "Home Hero"
      }), /*#__PURE__*/_jsx(Sections, {
        error: error,
        loading: loading,
        sections: sections,
        remainingSections: remainingSections
      })]
    })
  });
}
function Sections({
  loading,
  error,
  sections,
  remainingSections
}) {
  if (loading) return /*#__PURE__*/_jsx(LoadingSpinner, {
    grow: true,
    size: "medium",
    marginBlockStart: "1200"
  });
  if (error) return /*#__PURE__*/_jsx(ErrorMessage, {
    type: "badRequest"
  });
  const collection = createMockCollection();
  const listings = Array.from({
    length: 6
  }, createMockListing);
  return /*#__PURE__*/_jsxs(NavMarker, {
    name: "INDEX_LOAD",
    children: [sections === null || sections === void 0 ? void 0 : sections.map((section, index) => /*#__PURE__*/_jsx(SliderSection, {
      title: translateSectionTitle(section.sectionType),
      cards: section.cards
    }, index)), /*#__PURE__*/_jsx(CollectionSection, {
      title: collection.name,
      description: collection.description,
      imageUrl: collection.imageSrc,
      collectionSlug: collection.name,
      cards: listings,
      collectionId: collection.collectionId
    }), remainingSections === null || remainingSections === void 0 ? void 0 : remainingSections.map((section, index) => /*#__PURE__*/_jsx(SliderSection, {
      title: translateSectionTitle(section.sectionType),
      cards: section.cards
    }, index))]
  });
}